<template>
  <v-card class="cursor-pointer" @click="notificationClicked">
    <v-card-title class="py-2">
      <span class="notification-text title-text-base" v-html="type" />
      <v-spacer />
      <span class="notification-text title-date-time">{{ dateTime }}</span>
    </v-card-title>
    <v-divider />
    <v-card-text>
      <v-row v-if="displayType === AgentNotificationsDisplayType" dense>
        <v-col cols="12">
          <v-row>
            <v-col class="blue-header-text-container">
              <span class="notification-text blue-header-text">Title: </span>
            </v-col>
            <v-col>
              <span
                class="notification-text gray-content-text"
                v-html="title"
              />
            </v-col>
          </v-row>
        </v-col>
        <v-col cols="12" class="mt-4 mb-1">
          <v-row row>
            <v-col class="blue-header-text-container">
              <span class="notification-text blue-header-text">Body: </span>
            </v-col>
            <v-col>
              <span class="notification-text gray-content-text" v-html="body" />
            </v-col>
          </v-row>
        </v-col>
      </v-row>
      <v-row v-if="displayType === AllAgentsNotificationsDisplayType">
        <v-col class="pt-2">
          <v-avatar color="primary" size="28">
            <span class="text-white body-2">{{ iconText }}</span>
          </v-avatar>
          <span class="agent-name pl-2">
            {{ agentDisplayName }}
          </span>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
import useFormatters from "@/mixins/formatters";

const AgentNotificationsDisplayType = "agent-notifications";
const AllAgentsNotificationsDisplayType = "all-agents-notifications";

export default {
  name: "AgentDetailNotificationCard",
  props: {
    displayType: {
      type: String,
      default: AgentNotificationsDisplayType,
    },
    notification: {
      type: Object,
      default: () => {},
    },
    category: {
      type: String,
      default: "",
    },
  },
  computed: {
    displayPointer() {
      return this.displayType === AllAgentsNotificationsDisplayType;
    },
    type() {
      if (this.notification.type) {
        switch (this.notification.type) {
          case "UNDER_CONTRACT_1_DAY_PAST":
            return "Under Contract: <span style='color: #af322f;'>1 Day Past</span>";

          case "NEW_REFERRAL":
            return `<span style="color: #00c8a8;">${this.prettyPrintEnum(
              this.notification.type,
            )}</span>`;

          default:
            return `${this.prettyPrintEnum(this.notification.type)}`;
        }
      }

      return "Undefined";
    },
    dateTime() {
      if (this.notification.sent) {
        // all brokerage notifications for the past 24 hours. show full date
        if (this.displayType === AllAgentsNotificationsDisplayType) {
          return `${this.formatDateMonthDay(
            this.notification.sent,
          )} @ ${this.formatTime(this.notification.sent)}`;
        }

        // agent's notifications
        return `${this.formatTime(this.notification.sent)}`;
      }

      return "";
    },
    title() {
      if (this.notification && this.notification.title) {
        if (
          this.notification.referralName &&
          this.notification.referralName !== ""
        ) {
          if (
            this.notification.title.includes(this.notification.referralName)
          ) {
            return this.notification.title.replace(
              this.notification.referralName,
              `<b>${this.notification.referralName}</b>`,
            );
          }
        }

        return this.notification.title;
      }

      return "-";
    },
    body() {
      if (this.notification && this.notification.text) {
        if (
          this.notification.referralName &&
          this.notification.referralName !== ""
        ) {
          if (this.notification.text.includes(this.notification.referralName)) {
            return this.notification.text.replace(
              this.notification.referralName,
              `<b>${this.notification.referralName}</b>`,
            );
          }
        }

        return this.notification.text;
      }

      return "-";
    },
    iconText() {
      if (
        this.notification.agentDisplayName &&
        this.notification.agentDisplayName.length > 0
      ) {
        return this.notification.agentDisplayName.charAt(0).toUpperCase();
      }

      return "-";
    },
    agentDisplayName() {
      if (
        this.notification.agentDisplayName &&
        this.notification.agentDisplayName !== ""
      ) {
        return this.titleCase(this.notification.agentDisplayName);
      }

      return "Not Available";
    },
  },
  data() {
    return {
      AgentNotificationsDisplayType: AgentNotificationsDisplayType, // exposed to template
      AllAgentsNotificationsDisplayType: AllAgentsNotificationsDisplayType, // exposed to template
    };
  },
  methods: {
    ...useFormatters(),
    notificationClicked() {
      this.$emit("clicked", this.notification);
    },
  },
};
</script>

<style scoped>
.notification-text {
  font-family: Avenir, sans-serif;
  font-style: normal;
  font-size: 14px;
}

.title-text-base {
  font-weight: 800;
  color: #383838;
}

.title-date-time {
  font-weight: normal;
  color: #b2b2b2;
}

.blue-header-text-container {
  min-width: 50px;
  max-width: 50px;
}

.blue-header-text {
  display: inline-block;
  width: 50px;
  color: #4a90e2;
  font-weight: 800;
}

.gray-content-text {
  font-weight: normal;
  color: black;
}

.agent-name {
  font-family: Avenir, sans-serif;
  font-style: normal;
  font-size: 14px;
  font-weight: 400;
  color: #383838;
  padding-left: 4px;
}
</style>
